import Error from '@/components/error/Error';
import { Container } from '@montugroup/design-system';

export function PageError() {
  return (
    <Container maxWidth="xl">
      <Error status={500} />
    </Container>
  );
}

export default PageError;
